const CustomErrorMessages = {
  CONFIG_NOT_PROVIDED:
    "Configuration not provided. Please ensure all required parameters are supplied.",
  CONFIG_VALIDATION_FAILED:
    "Configuration validation failed. Check if the configuration meets the required criteria.",
  CONFIG_FILE_NOT_FOUND:
    "Configuration file not found. Verify the file path and access permissions.",
  CONFIG_FILE_READ_ERROR:
    "Error reading the configuration file. Ensure the file is accessible and in the correct format.",
  CONFIG_PERMISSION_ERROR:
    "Permission error accessing the configuration file. Ensure proper permissions are set.",
  CONFIG_MISSING_REQUIRED_PARAMETER:
    "One or more required parameters are missing from the configuration.",
  CONFIG_INCOMPATIBLE_WITH_SERVICE_VERSION:
    "Configuration is incompatible with the current service version. Update the configuration to match the new version.",
  CONFIG_REQUEST_FAILED: "Config request failed",

  SERVICE_NOT_AVAILABLE: "The service is currently unavailable.",
  SERVICE_ALREADY_RUNNING:
    "The service is already running. Please wait for it to complete or stop it before starting again",
  SERVICE_NOT_RUNNING: "The service is not running.",
  SERVICE_FAILED_TO_INIT:
    "Failed to start the service. There was an issue initializing the service. Please check the configuration and try again.",
  SERVICE_FAILED_TO_START:
    "Failed to start the service. There was an issue starting the service. Please check the configuration and try again.",
  SERVICE_FAILED_TO_STOP:
    "Failed to stop the service. There was an issue while shutting down the service.",
  SERVICE_INVALID_REQUEST: "The service operation timed out.",
  SERVICE_AUTHENTICATION_FAILURE:
    "The service received an invalid request. Please ensure the request parameters are correct.",
  SERVICE_UPGRADE_REQUIRED: "Authentication failed while accessing the service. ",
  SERVICE_RATE_LIMIT_EXCEEDED: "You have exceeded the rate limit for the service. ",
  SERVICE_INTERNAL_ERROR: "An internal error occurred in the service.",

  CALLBACK_NOT_PROVIDED: "Callback function not provided.",
  CALLBACK_ARGUMENT_ERROR: "Error in callback arguments.",
  CALLBACK_EXECUTION_FAILED: "Failed to execute the callback function.",

  BROWSER_NOT_SUPPORTED: "Your current browser is not supported. ",
  BROWSER_VERSION_NOT_SUPPORTED:
    "Your browser version is not supported. Please update to the latest version for full functionality.",
  BROWSER_PERMISSION_ERROR: "Browser permission error.",
  BROWSER_CAMERA_PERMISSION_NOT_GRANTED: "Camera permission not granted.",
  BROWSER_MICROPHONE_PERMISSION_NOT_GRANTED: "Microphone permission not granted.",
  BROWSER_WINDOW_MANAGEMENT_PERMISSION_NOT_GRANTED: "Window management permission not granted.",

  INTERNET_INSUFFICIENT_BANDWIDTH:
    "Insufficient bandwidth. Your internet connection is too slow to perform this operation. Please try again with a faster connection.",
  INTERNET_OFFLINE: "You are currently offline. Please connect to the internet to proceed.",

  MULTIPLE_SCREEN_DETECTED: "Multiple screens detected.",
  MULTIPLE_SCREEN_VIOLATION: "Multiple screen violation.",
  MULTIPLE_SCREENS_DETECTED_ERROR: "Error checking for multiple screens detected.",

  GET_SYSTEM_METADATA_ERROR: "Error while getting system metadata",
  IS_BROWSER_COMPATIBILITY_ERROR: "Error while checking browser compatibility",
  DETECT_SYSTEM_COMPATIBILITY_ERROR: "Error while getting system data",
  BOWSER_NOT_FOUND: "Bowser is not accessible",
  GET_PARSER_NOT_DEFINED: "Bowser.getParser() function is not defined",
  INCORRECT_CONFIG: "The Config Provided is Incorrect.",
  COMPATIBLE_BROWSERS_MISSING: "Compatible Browsers is missing in Config provided.",

  BROWSER_PERMISSION_NOT_GRANTED_ERROR: "Window management permission not granted.",
  STOPPING_SCREEN_DETECTION_ERROR: "Error stopping screen detection.",

  SCREEN_CHANGE_HANDLER_ERROR: "Error in handling screen change.",
  HARDWARE_ACCELERATION_NOT_ENABLED: "Hardware Acceleration is not Allowed",

  START_WEBCAM_VIDEO_ERROR: "Error starting webcam: ",
  START_SCREEN_SHARE_VIDEO_ERROR: "Error starting screen share: {{error}}",
  REQUEST_WEBCAM_MEDIA_STREAM_ERROR: "Error requesting webcam media stream.",
  WEBCAM_PERMISSION_DENIED: "Permission denied. User did not grant access to the webcam.",
  WEBCAM_NOT_FOUND: "No webcam device found.",
  WEBCAM_NOT_READABLE: "Could not access the webcam. It may already be in use.",
  REQUEST_AUDIO_STREAM_ERROR: "Error requesting audio stream.",
  MICROPHONE_PERMISSION_DENIED: "Permission denied. User did not grant access to the microphone.",
  MICROPHONE_NOT_FOUND: "No microphone found.",
  MICROPHONE_NOT_READABLE: "Could not access the microphone. It may already be in use.",
  REQUEST_SCREEN_SHARE_STREAM_ERROR: "Error accessing the screen share stream: ",
  ENUMERATE_DEVICES_ERROR: "Error enumerating media devices.",
  FULL_SCREEN_NOT_SHARED_ERROR: "Full Screen not Shared ",
  VALID_SCREEN_NOT_SHARED_ERROR: "Valid Screen not Shared ",
  SCREEN_SHARE_DENIED_ERROR: "Screen Share Permission Denied",
  DEVICE_NOT_IN_WINDOW: "mediaDevices is not present in window.navigators",
  DEVICE_TYPE_NOT_GIVEN: "Device Type not given.",

  AUTO_PROCTORING_WEBCAM_DISCONNECTED_ERROR: "Webcam disconnected.",
  AUTO_PROCTORING_MICROPHONE_DISCONNECTED_ERROR: "Microphone disconnected.",
  AUTO_PROCTORING_SCREENSHARE_STOPPED_ERROR: "Screen share stopped.",
  AUTO_PROCTORING_BROWSER_PERMISSION_TOGGLE_ERROR: "Browser permissions toggled.",

  AUTO_PROCTORING_NOT_INITIALIZED: "Auto Proctoring tool is not initialized",
  AUTO_PROCTORING_SELECTOR_NOT_PROVIDED: "Selector is not provided",

  FAILED_TO_GET_ORGANIZATION_DETAILS: "Failed to get organization details",
  FAILED_TO_GET_CLIENT_USER_MAPPING: "Failed to get client user mapping",
  FAILED_TO_GET_TEST_DETAILS_FROM_USER_GUID: "Failed to get test details from user guid",
  FAILED_TO_GET_TEST_DETAILS_FROM_CLIENT_TEST_GUID:
    "Failed to get test details from client test guid",
  FAILED_TO_SET_PROCTOR_SESSION: "Failed to set proctor session",
  AUTO_PROCTORING_FAILED_TO_ADD_CANDIDATE_FOR_MANUAL_PROCTORING:
    "Failed to add candidate for manual proctoring",

  START_BROWSER_PERMISSION_CHANGE_DETECTION_ERROR:
    "An error occurred while starting browser permission change detection.",
  STOP_BROWSER_PERMISSION_CHANGE_DETECTION_ERROR:
    "An error occurred while stopping browser permission change detection.",
  GET_BROWSER_PERMISSION_STATUS_ERROR: "An error occurred while getting browser permission status.",

  CHECK_INSPECT_WINDOW_OPEN_ERROR: "Error while checking if Inspect Window is open",
  GET_SCROLL_BAR_WIDTH_ERROR: "Error while getting scroll bar width",
  CHECK_WINDOW_RESIZED_ERROR: "Error while cheking if window was resized",
  TAB_SWITCH_HANDLER_ERROR: "Error while handling tab switch",
  START_TAB_SWITCH_DETECTION_ERROR: "Error starting Tab Switch Detection",
  STOP_TAB_SWITCH_DETECTION_ERROR: "Error stopping Tab Switch Detection",

  CHAT_UI_TOOL_NOT_INITIALIZED: "Chat UI tool is not initialized",
  CHAT_UI_TOOL_SELECTOR_NOT_PROVIDED: "Selector is not provided",

  PROCTORING_SETTINGS_TOOL_NOT_INITIALIZED: "Proctoring Settings tool is not initialized",
  PROCTORING_SETTINGS_TOOL_SELECTOR_NOT_PROVIDED: "Selector is not provided",

  FAQ_SDK_NOT_INITIALIZED: "FAQ SDK is not initialized",
  FAQ_SDK_SELECTOR_NOT_PROVIDED: "Selector is not provided",

  VERIFICATIONS_STEPS_SDK_NOT_INITIALIZED: "Verification steps sdk is not initialized",
  VERIFICATIONS_STEPS_SDK_SELECTOR_NOT_PROVIDED: "Selector is not provided",

  REPORT_SDK_NOT_INITIALIZED: "Report sdk is not initialized",
  REPORT_SDK_SELECTOR_NOT_PROVIDED: "Selector is not provided",

  PROVIDED_TEST_GUID_IS_NOT_MAPPED_ON_TESTMAVERICK_DATABASE:
    "The provided testGUID is not mapped in the Test Maverick database",
  CANNOT_RESET_TEST_AFTER_THE_TEST_START_TIME:
    "Cannot reset the test after the designated test start time has elapsed",
  PROVIDED_DATE_IS_NOT_IN_CORRECT_FORMAT: "The provided date-time is not in UTC format.",
  PROVIDED_TESTGUID_IS_INCORRECT: "The provided testGUID is incorrect",
  PROVIDED_PROCTORING_MODE_IS_INCORRECT: "The provided proctoring mode is incorrect",
  TEST_GUID_IS_NOT_PROVIDED: "The testGuid is a required parameter.",
  TEST_START_TIME_SHOULD_BE_EARLIER_THAN_TEST_END_TIME:
    "The test start time should be earlier than the test end time",
  ENTER_A_VALID_NUMBER_FOR_EXPECTED_CANDIDATES:
    "Please enter a valid non-negative number. Expected candidates should be a non-negative integer.",
  ENTERED_NUMBER_EXCEEDS_MAXIMUM_ALLOWED_CANDIDATES:
    "The entered number exceeds the maximum allowed candidates. Please enter a valid number.",

  SENTRY_INIT_ERROR: "Failed to initialize sentry",
  FAILED_TO_GENERATE_REPORT: "Failed to submit test",

  // indexedDb
  INDEXED_DB_FAILED_TO_INITIALIZE: "Failed to initialize indexedDb",
  INDEXED_DB_FAILED_TO_START: "Failed to start indexedDb",
  INDEXED_DB_FAILED_TO_STOP: "Failed to stop indexedDb",
  INDEXED_DB_FAILED_TO_SAVE: "Failed to save in indexedDb",

  LIVE_STREAMING_FAILED_TO_INITIALIZE: "Failed to initialize Live streaming",
  LIVE_STREAMING_FAILED_TO_START: "Failed to start Live streaming",
  LIVE_STREAMING_FAILED_TO_STOP: "Failed to stop Live streaming",
  LIVE_STREAMING_FAILED_TO_ADD_LISTENERS: "Failed to add listeners",
  LIVE_STREAMING_FAILED_TO_REMOVE_LISTENERS: "Failed to remove listeners",

  LIVE_STREAMING_FAILED_TO_LISTEN_TO_MEDIA_START_REQUEST: "Failed to listen to media start request",
  LIVE_STREAMING_FAILED_TO_LISTEN_TO_MEDIA_STOP_REQUEST: "Failed to listen to media stop request",
  LIVE_STREAMING_FAILED_TO_SEND_MEDIA_START_REQUEST: "Failed to send media start request",
  LIVE_STREAMING_FAILED_TO_SEND_MEDIA_STOP_REQUEST: "Failed to send media stop request",
  LIVE_STREAMING_FAILED_TO_REMOVE_MEDIA_START_REQUEST_LISTENER:
    "Failed to remove media start request",
  LIVE_STREAMING_FAILED_TO_REMOVE_MEDIA_STOP_REQUEST_LISTENER:
    "Failed to remove media stop request",

  LIVE_STREAMING_FAILED_TO_LISTEN_TO_PEER_OFFER: "Failed to listen to peer offer",
  LIVE_STREAMING_FAILED_TO_LISTEN_TO_PEER_ANSWER: "Failed to listen to peer answer",
  LIVE_STREAMING_FAILED_TO_SEND_PEER_OFFER: "Failed to send peer offer",
  LIVE_STREAMING_FAILED_TO_SEND_PEER_ANSWER: "Failed to send peer answer",
  LIVE_STREAMING_FAILED_TO_REMOVE_PEER_OFFER_LISTENER: "Failed to remove peer offer",
  LIVE_STREAMING_FAILED_TO_REMOVE_PEER_ANSWER_LISTENER: "Failed to remove peer answer",

  LIVE_STREAMING_FAILED_TO_LISTEN_TO_ICE_CANDIDATES: "Failed to listen to ice candidates",
  LIVE_STREAMING_FAILED_TO_SEND_ICE_CANDIDATES: "Failed to send ice candidates",
  LIVE_STREAMING_FAILED_TO_REMOVE_ICE_CANDIDATES_LISTENER: "Failed to remove ice candidates",

  LIVE_STREAMING_FAILED_TO_CREATE_PEER_CONNECTION: "Failed to create peer connection",
  LIVE_STREAMING_FAILED_TO_CLOSE_PEER_CONNECTION: "Failed to close peer connection",
  LIVE_STREAMING_FAILED_TO_SET_LOCAL_DESCRIPTION: "Failed to set local description",
  LIVE_STREAMING_FAILED_TO_SET_REMOTE_DESCRIPTION: "Failed to set remote description",
  LIVE_STREAMING_FAILED_TO_ADD_MEDIA_TRACK: "Failed to add media track",
  LIVE_STREAMING_FAILED_TO_REMOVE_MEDIA_TRACK: "Failed to remove media track"
};

export default CustomErrorMessages;
